import { render } from "./tag-add-list.vue?vue&type=template&id=cf5bf752&scoped=true"
import script from "./tag-add-list.vue?vue&type=script&lang=js"
export * from "./tag-add-list.vue?vue&type=script&lang=js"

import "./tag-add-list.vue?vue&type=style&index=0&id=cf5bf752&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf5bf752"]])

export default __exports__